import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';
import { isBoolean } from 'lodash-es';

export default class CheckUserHasPin extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'auth-temp-checkUserHasPin',
      payload: {
        user_id: this._payload.user_id,
        ...this._payload
      },
      disableLoaders: true
    });
  }
  
  onSuccess(data) {
    super.onSuccess(data);
    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        user: {
          hasPin: isBoolean(data.has_pin) ? data.has_pin : null
        }
      }
    })
  };
}
